import Service from '@ember/service';
import { service } from '@ember/service';
import type SessionContextService from './session-context';
import type PartnerService from './partner';

export default class ZendeskService extends Service {
  @service declare sessionContext: SessionContextService;
  @service declare partner: PartnerService;

  get isEnabledForPartner() {
    return this.partner.isZendeskEnabled;
  }

  // @ts-expect-error: this is ok for now
  zendeskAction(...args) {
    return !!window.zE && window.zE(...args);
  }

  hideAllChatWidgets() {
    // Always hide the Zendesk messenger and Forethought widget on load.
    // Chat is opened explicitly via the sidebar Support button.
    this.zendeskAction('messenger', 'hide');
    window.Forethought?.('widget', 'hide');
  }

  hideForethoughtWidget() {
    window.Forethought?.('widget', 'hide');
  }

  openWebChatWindow() {
    if (window.Forethought) {
      // Must 'show' first to un-hide the widget before 'open' can work
      window.Forethought('widget', 'show');
      window.Forethought('widget', 'open');
    } else {
      // Forethought is not mounted (disabled for the partner), so fall back
      // to the Zendesk messenger directly
      this.zendeskAction('messenger', 'show');
      this.zendeskAction('messenger', 'open');
    }
  }

  clearUser() {
    this.zendeskAction('messenger', 'logoutUser');
    this.zendeskAction('messenger', 'hide');
    window.Forethought?.('widget', 'hide');
  }

  setWidgetLocale() {
    if (this.isEnabledForPartner) {
      this.zendeskAction('messenger:set', 'locale', window.navigator.language);
    }
  }
}
